<script>
import _ from 'lodash';
import cFormGroup from './cFormGroup.vue';
import {h, resolveComponent} from "vue";

export default {
  name: 'cForm',
  components: {cFormGroup},
  props: {
    schema: {
      type: Object,
      default: () => {
      },
    },
    model: {
      type: Object,
      default: () => {
      },
    },
    cols: {
      type: Number,
      default: 1,
    },
    labelWeight: {
      type: Number,
      default: 700,
    },
    labelWidth: {
      type: Number,
      default: undefined,
    },
    view: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errors: [],
    };
  },
  computed: {
    fields() {
      let res = [];
      if (this.schema && this.schema.fields) {
        _.forEach(this.schema.fields, field => {
          res.push(field);
        });
      }
      return res;
    },
  },
  methods: {
    fieldVisible(field) {
      if (_.isFunction(field.visible)) return field.visible.call(this, this.model, field, this);
      if (_.isNil(field.visible)) return true;
      return field.visible;
    },
    onModelUpdated(newVal, schema) {
      this.$emit('model-updated', newVal, schema);
    },
    onValidate(param) {
      this.$refs[param.formId].$refs[param.fieldId].$children[0].isValid();
      if (param.focus) this.$refs[param.formId].$refs[param.fieldId].$children[0].focus();
    },
  },
  render() {
    const {error, model, cols, schema, fields, labelWeight, labelWidth, view} = this;
    const cFormGroup = resolveComponent('c-form-group')

    let slots = null;

    if (this.$slots.default) {
      slots = this.$slots.default[0]();
    } else {
      slots = this.$slots;
    }

    const formBuilder =
        schema.fields &&
        fields.map((field, idx) => {
          return field.hr
              ? h('div', {
                class: 'c-form-hr',
                style: {
                  display: field.hide && 'none',
                },
              })
              : h(
                  cFormGroup,
                  {
                    view,
                    error,
                    model,
                    cols,
                    labelWeight,
                    labelWidth,
                    key: idx,
                    field: field,
                    onModelUpdated: this.onModelUpdated,
                    ref: field.formId && field.formId,
                    style: {
                      display: field.hide ? 'none' : 'flex',
                    },
                  },
                  [field.slotName && slots[field.slotName]()],
              );
        });

    return (
        h(
            'div',
            {
              class: {
                'c-form': true,
                'c-form-view': view,
              },
            },
            [formBuilder],
        )
    );
  },
};
</script>

<style lang="scss" scoped>
.c-form {
  display: inline-flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;

  &-hr {
    width: 100%;
    height: 1px;
    margin-bottom: 20px;
    background-color: var(--color-ui-ui08);
  }
}
</style>
